<template>
  <div class="carousel">
    <!--    <div class="btn left" @click="change(-1)">-</div>-->
    <!--    <div class="btn right" @click="change(+1)">+</div>-->
    <div class="item" v-for="(game,i) in games" :class="boxClass(i)" @click="clickItem(i)">
      <img :src="gameImg(game.name)" alt="">
    </div>
    <div class="balls">
      <div class="dot" v-for="(game,i) in games" :class="dotClass(i)" @click="clickDot(i)">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "carousel",
  props: ['type', 'name'],
  data() {
    return {
      nowIndex: 4,
      animate: false,
      timeout: null
    }
  },
  computed: {
    games() {
      return this.$dataManager.findGames()
    },
    total() {
      return this.$dataManager.findGames().length
    },
    prev() {
      return (this.nowIndex - 1 < 0) ? this.total - 1 : this.nowIndex - 1
    },
    after() {
      return (this.nowIndex + 1 === this.total) ? 0 : this.nowIndex + 1
    },
    prevHide() {
      return (this.nowIndex - 2 < -1) ? this.total - 2 : (this.nowIndex - 2 < 0) ? this.total - 1 : this.nowIndex - 2
    },
    afterHide() {
      return (this.nowIndex + 2 >= this.total) ? this.nowIndex + 2 - this.total : this.nowIndex + 2
    }
  },
  methods: {
    clickItem: function (idx) {
      switch (idx) {
        case this.prev:
          this.change(-1)
          break;
        case this.after:
          this.change(+1)
          break;
        case this.nowIndex:
          switch (this.$dataManager.findGamesType(this.games[this.nowIndex].gameId)) {
            case 'minigame':
              this.$router.push({name: 'minigame', params: {game: this.games[this.nowIndex].name}})
              break;
            case 'marblegame':
              this.$router.push({name: 'marblegame', params: {game: this.games[this.nowIndex].name}})
              break;
            case 'lottogame':
              this.$router.push({name: 'lottogame', params: {game: this.games[this.nowIndex].name}})
              break;
            case 'aresbetgame':
              this.$router.push({name: 'aresbetgame', params: {game: this.games[this.nowIndex].name}})
              break;
            case 'aeonbetgame':
              this.$router.push({name: 'aeonbetgame', params: {game: this.games[this.nowIndex].name}})
              break;
          }
          break;
      }
    },
    clickDot: function (idx) {
      this.nowIndex = idx
    },
    change: function (i) {
      if (!this.animate) {
        this.nowIndex += i
        var $this = this;
        $this.animate = true
        this.timeout = setTimeout(() => {
          $this.animate = false
        }, 305)
      }
    },
    boxClass(idx) {
      return (idx == this.nowIndex) ? 'now' : (idx == this.prev) ? 'pre' : (idx == this.after) ? 'after' : (idx == this.prevHide) ? 'prevHide' : (idx == this.afterHide) ? 'afterHide' : ''
    },
    dotClass(idx) {
      return (idx == this.nowIndex) ? 'now' : ''
    },
    getWidth: function () {
      this.clientWidth = parseInt(document.querySelector('.trygame').offsetWidth)
    },
    gameImg: function (game) {
      var url = 'images/game/' + game + '/banner_small.jpg';
      return url
    },
  },
  mounted: function () {

    this.games.forEach((item, idx) => {
      if (item.name === this.name) {
        this.nowIndex = idx
      }
    })
  },
  watch: {
    nowIndex(val, old) {
      if (val == this.total) {
        this.nowIndex = 0
      }
      if (val < 0) {
        this.nowIndex = this.total - 1
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import 'carousel';
</style>
